import NavHead from './NavHead';

export default NavHead;
